














import { Component, Vue } from 'vue-property-decorator';
import AppBar from '@/components/AppBar.vue';
import AppWindow from '@/components/AppWindow.vue';

@Component({
    name: 'App',
    components: {
        AppBar,
        AppWindow,
    },
})
export default class extends Vue {
    private get width() {
        const windowWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
        const isMobileView = windowWidth < 768;
        const optimalMinWidth = 320;
        const minWidth = windowWidth < optimalMinWidth ? windowWidth : optimalMinWidth;
        return isMobileView ? `position: absolute;left: 0px; min-width: ${minWidth}px` : '';
    }
}
